export const hslToHsv = c => {
  const v = c.lightness + c.saturation * Math.min(c.lightness, 1 - c.lightness);
  const s = v === 0 ? 0 : 2 * (1 - c.lightness / v);
  return {
    hue: c.hue,
    saturation: s,
    value: v
  };
};
//# sourceMappingURL=hslToHsv.js.map